/*
 * Copyright (c) 2021. Michael Clovis
 * This program is free software: you can redistribute it and/or modify
 *     it under the terms of the GNU Affero General Public License as published by
 *     the Free Software Foundation, either version 3 of the License, or
 *     (at your option) any later version.
 *
 *     This program is distributed in the hope that it will be useful,
 *     but WITHOUT ANY WARRANTY; without even the implied warranty of
 *     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *     GNU Affero General Public License for more details.
 *
 *     You should have received a copy of the GNU Affero General Public License
 *     along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import moment from "moment";
import {User} from "./User";

export class CheckIn {
  id = 0;
  place_id = 0;
  licence = "";
  display_name = "";
  osm_type = "";
  osm_id = 0;
  lat = "0";
  lon = "0";
  place_rank = 0;
  category = "";
  type = "";
  importance = 0;
  addresstype = "";
  name = "";
  address = {
    house_number: "",
    road: "",
    town: "",
    county: "",
    state: "",
    postcode: "",
    country: "",
    country_code: "",

  };
  boundingbox = [];
  time = new moment();
  employee = new User();

  constructor() {
  }

  static convertObject(obj) {
    let checkin = new CheckIn();
    checkin = Object.assign(checkin, obj);
    //checkin.place_id = parseInt(obj.place_id);
    checkin.time = new moment(checkin.time);
    checkin.employee = User.convertObject(checkin.employee);
    return checkin;
  }
  // toJSON(){
  //   JSON.stringify(this)
  // }
}


